'use client';

import { forwardRef, useId } from 'react';
import Link from 'next/link';
import { useTranslation } from '@weareconceptstudio/core';

const CustomLink = forwardRef(
	({ url, className = '', prefetch = true, scroll = true, replace = false, external = false, ...props }, ref) => {
		const id = useId();

		const { translate, selectedLang } = useTranslation();

		const href =
			typeof url === 'object'
				? { ...url, pathname: external ? url.pathname : `/${selectedLang}${url.pathname}` }
				: external
				? url
				: `/${selectedLang}${url}`;
		const ariaLabel = translate(
			props.text?.replaceAll('/', '') ||
				props.ariaLabel ||
				(typeof url === 'object' ? url.pathname?.replaceAll('/', '') : url?.replaceAll('/', ''))
		);

		return (
			<Link
				id={id}
				ref={ref}
				href={href}
				scroll={scroll}
				replace={replace}
				prefetch={prefetch}
				aria-label={ariaLabel}
				onClick={props.onClick}
				onMouseOut={props.onMouseOut}
				onMouseOver={props.onMouseOver}
				onMouseEnter={props.onMouseEnter}
				onMouseLeave={props.onMouseLeave}
				className={`link-item ${className}`}
				rel={external ? 'noopener noreferrer' : undefined}
				target={external ? '_blank' : props.target || '_self'}>
				{props.children || props.content}
			</Link>
		);
	}
);

CustomLink.displayName = 'CustomLink';

export default CustomLink;
